import {
  AudioConfig,
  AudioInputStream,
  CancellationReason,
  SpeechConfig,
  SpeechRecognizer,
} from 'microsoft-cognitiveservices-speech-sdk'
import apis from '../../../../modules/apis'
import { axiosPost } from '../../../../modules/axiosHelper'

export type PushStream = ReturnType<typeof AudioInputStream.createPushStream> & {
  writes: (x: Float32Array[]) => Promise<Float32Array[] | undefined>
}

const getAzureToken = async () => {
  if (localStorage.azureToken) {
    try {
      const [region, expire, token] = localStorage.azureToken.split('|')
      if (Date.now() < parseInt(expire)) return { region, token }
    } catch (e) {
      console.log(e)
    }
  }
  for (let i = 0; i < 5; i++) {
    try {
      const res = await axiosPost(apis.conversation.token.speech())
      //기존 1분에서 5분으로 늘렸습니다.
      localStorage.azureToken = `${res.region}|${Date.now() + 300000}|${res.token}`
      if (res?.token) return { region: res.region, token: res.token }
    } catch (e) {
      await new Promise((r) => setTimeout(r, 300))
    }
  }
  throw new Error('Failed to get Azure token')
}

export async function AzureSpeechRecognizer({ setTranscription }: { setTranscription?: (text: string) => void } = {}) {
  const pushStream: PushStream = AudioInputStream.createPushStream() as any
  const { region, token } = await getAzureToken()
  const speechConfig = SpeechConfig.fromAuthorizationToken(token, region)
  speechConfig.speechRecognitionLanguage = 'en-US'
  const audioConfig = AudioConfig.fromStreamInput(pushStream)
  const recognizer = new SpeechRecognizer(speechConfig, audioConfig)
  let recognized = ''
  let current = ''
  let isDestroyed = false

  pushStream.writes = async (x: Float32Array[]) => {
    for (const i of x) pushStream.write(new Int16Array(i.map((i) => i * 32767)).buffer)
    return x
  }

  const destroy = () => {
    if (isDestroyed) return
    isDestroyed = true
    try {
      recognizer.close()
    } catch (e) {
      console.log(e)
    }
    try {
      speechConfig.close()
    } catch (e) {
      console.log(e)
    }
    try {
      pushStream.close()
    } catch (e) {
      console.log(e)
    }
    try {
      audioConfig.close()
    } catch (e) {
      console.log(e)
    }
  }

  recognizer.sessionStopped = (s, e) => {
    recognizer.stopContinuousRecognitionAsync()
  }

  recognizer.recognizing = (s, e) => {
    current = e.result.text
    if (setTranscription) setTranscription(recognized + ' ' + current)
  }

  recognizer.recognized = (s, e) => {
    if (e.result.text) {
      recognized = recognized.concat(' ', e.result.text)
      if (setTranscription) setTranscription(recognized)
      current = ''
    }
  }

  recognizer.canceled = (s, e) => {
    console.log('end', e)
    if (e.reason == CancellationReason.Error) {
      console.log(`"CANCELED: ErrorCode=${e.errorCode}`)
      console.log(`"CANCELED: ErrorDetails=${e.errorDetails}`)
    }
    recognizer.stopContinuousRecognitionAsync(destroy)
  }

  recognizer.startContinuousRecognitionAsync()

  return {
    pushStream,
    destroy: () =>
      new Promise<string>((res, rej) => {
        const timeout = setTimeout(() => {
          rej(new Error('Failed to access Azure API'))
        }, 10000)
        recognizer.stopContinuousRecognitionAsync(() => {
          destroy()
          res(recognized)
          clearTimeout(timeout)
        })
      }),
  }
}
